export abstract class NXTPage {
    abstract initialize(): void;
}
